<script lang="ts">
  import Router from "svelte-spa-router";

  import Sidebar from "./lib/components/Sidebar.svelte";
  import Topbar from "./lib/components/Topbar.svelte";
  import CommandPalette from "./lib/components/CommandPalette.svelte";

  import Home from "./routes/Home.svelte";
  import Category from "./routes/Category.svelte";
  import SopDetail from "./routes/SopDetail.svelte";
  import Search from "./routes/Search.svelte";
  import Changelog from "./routes/Changelog.svelte";
  import Admin from "./routes/Admin.svelte";
  import AdminEdit from "./routes/AdminEdit.svelte";
  import AdminNew from "./routes/AdminNew.svelte";
  import NotFound from "./routes/NotFound.svelte";

  const routes = {
    "/": Home,
    "/category/:cat": Category,
    "/sop/:slug": SopDetail,
    "/search": Search,
    "/changelog": Changelog,
    "/admin": Admin,
    "/admin/new": AdminNew,
    "/admin/edit/:slug": AdminEdit,
    "*": NotFound,
  };
</script>

<div class="flex min-h-screen bg-bg text-text">
  <Sidebar />
  <div class="flex-1 flex flex-col min-w-0">
    <Topbar />
    <main class="flex-1 px-4 py-4 sm:px-6 sm:py-5 lg:px-8 lg:py-6 max-w-6xl w-full">
      <Router {routes} />
    </main>
  </div>
  <CommandPalette />
</div>
